import script from "./ChinaUSAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChinaUSAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./ChinaUSAdminPage.vue?vue&type=style&index=0&id=14ac61f1&lang=css"

const __exports__ = script;

export default __exports__